const GetUniqueAge = () => {

    let age = [];
    let i = 0;

    let ageObj = [
        {label: "อายุ 0-14 ปี", value: "อายุ 0-14 ปี"}, {label: "อายุ 15-59 ปี", value: "อายุ 15-59 ปี"},
        {label: "อายุ 60-74 ปี", value: "อายุ 60-74 ปี"}, {label: "อายุ 75-84 ปี", value: "อายุ 75-84 ปี"},
        {label: "อายุ 85 ปีขึ้นไป", value: "อายุ 85 ปีขึ้นไป"},
    ];

    for(i=0;i<ageObj.length;i++){
        if(!age.includes(ageObj[i].value)){
            age.push(ageObj[i].value);
        }
    }
    return { age, ageObj };
}
 
export default GetUniqueAge;